import { ProgressBar } from '@petsmart-ui/sparky';

import { BulkPromoAction, PromoJobStatus } from '@/constants';
import { type JobDetails } from '@/types';
import { formatMSTDateCustom } from '@/utils';

import { createTableConfig } from '../../BaseTable/BaseTable';
import { ExportButton } from '../../ExportButton/ExportButton';

export const tableConfig = createTableConfig<JobDetails>([
    {
        key: 'action',
        header: 'Action',
        render: job => BulkPromoAction[job.action] ?? 'N/A',
    },
    {
        key: 'cartDiscount',
        header: 'Cart Discount',
        render: job => job.cartDiscount[0]?.key ?? 'N/A',
    },
    {
        key: 'createdAt',
        header: 'Started At',
        render: job => formatMSTDateCustom(job.createdAt),
    },
    {
        key: 'progress',
        header: 'Progress',
        render: job => (
            <ProgressBar
                total={job.action === 'export' ? job.generatedCodesCount : job.totalRequestedCodesCount}
                value={job.action === 'export' ? job.fetchedCodesCount || 0 : job.generatedCodesCount}
            />
        ),
    },
    {
        key: 'status',
        header: 'Status',
        render: job => PromoJobStatus[job.status.toLowerCase() as keyof typeof PromoJobStatus] ?? 'Unknown',
    },
    {
        key: 'export',
        header: 'Export',
        render: job =>
            job.status === 'failed' || job.status === 'pending' ? null : (
                <ExportButton jobId={job.jobId} status={job.status} action={job.action} />
            ),
    },
]);
